var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFire = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E03131",
  d: "M5.384 14.469a3.156 3.156 0 0 1 .27-3.81 5.9 5.9 0 0 0 1.002-2.12c.393.561.52 1.266.35 1.93a4.62 4.62 0 0 0 1.112-3.63 5.995 5.995 0 0 1 2.073 7.63c7.462-4 1.823-9.91.882-10.57a2.09 2.09 0 0 1-.27 2.35c-1.112-3.97-3.867-4.78-3.867-4.78.33 2-1.182 4.28-2.624 6a4.3 4.3 0 0 0-.56-2.16c-.111 1.43-1.313 2.64-1.633 4.16-.451 2 .33 3.44 3.265 5"
})));
export default SvgFire;